import React, {useState, useContext} from 'react';
import { AdminLoginContext } from "../context/AdminProvider"
import PersonCard from '../components/people/PersonCard'
import PersonBio from '../components/people/PersonBio';
import AffiliateCard from '../components/people/AffiliateCard'
import { Typography, Toolbar, Button, Grid, Container, Box } from '@mui/material';
import { useQuery } from '@apollo/client';
import { QUERY_PEOPLE } from '../utils/queries';
import CreatePerson from '../components/people/CreatePerson';
import { useProjectContext } from '../context/ProjectContext';


function People() {
    const { isLoggedIn } = useContext(AdminLoginContext)
    const { setEditPersonId } = useProjectContext()
    const { loading, data } = useQuery(QUERY_PEOPLE);
    const peopleList = data?.people || [];
    const [currentPerson, setCurrentPerson] = useState(null);

    const [newPerson, setNewPerson] = useState(false)
    const backToPeople = () => setNewPerson(false)
  
    const renderPerson = (details) => {
        setEditPersonId(null)
        setCurrentPerson(details._id)
    };

    const handleAdminEditFromCard = (details) => {
        setCurrentPerson(details._id)
        setEditPersonId(details._id)
    };

    const backToCards = () => {
        setEditPersonId(null)
        setCurrentPerson(null)
    }

    const currentPersonDetails = peopleList.find(person => person._id === currentPerson);
    const leadershipMembers = peopleList.filter(person => person.category === "Leadership");
    const staffMembers = peopleList.filter(person => person.category === "Staff").sort((a, b) => a.lastName.localeCompare(b.lastName));
    const postdocMembers = peopleList.filter(person => person.category === "Postdoc").sort((a, b) => a.lastName.localeCompare(b.lastName))
    const gradMembers = peopleList.filter(person => person.category === "Graduate Student").sort((a, b) => a.lastName.localeCompare(b.lastName));
    const facAffMembers = peopleList.filter(person => person.category === "Faculty Affiliate").sort((a, b) => a.lastName.localeCompare(b.lastName));
    const studAffMembers = peopleList.filter(person => person.category === "Student Affiliate").sort((a, b) => a.lastName.localeCompare(b.lastName));
    const alumniMembers = peopleList.filter(person =>person.category === "Center Alumnus").sort((a, b) => a.lastName.localeCompare(b.lastName));

    const emptyDetails = {
        firstName: null,
        lastName: null,
        title: [],
        image: null,
        description: null,
        research: null,
        projects: [],
        category: null,
        current: null,
        email: null,
        gscholar: null,
        linkedin: null,
        website: null,
        advisors: []
    }

    return (
        <Container maxWidth='xl' disableGutters={true}>
            {/* show loading if mongodb is being slow */}

            { newPerson ? (
                <CreatePerson onSubmit={backToPeople} details={emptyDetails} />
            ): (
                <div>
                {loading ? (
                    <div>Loading...</div>
                    ) : (
                        
                     currentPerson ? (
                        <Container maxWidth={false}>
                            <PersonBio details={currentPersonDetails} backToCards= {backToCards}/>
                        </Container>
                    ): (
                        <Container maxWidth={false}>
                            
                            {/* Admin Controls - Positioned at top for easy access */}
                            { isLoggedIn && (
                                <Box sx={{ display: 'flex', gap: 2, mb: 3, mt: 3, justifyContent: 'flex-end' }}>
                                    <Button 
                                        variant='contained' 
                                        onClick={() => {setNewPerson(true)}}
                                        aria-label="Add new member"
                                    >
                                        Add New Member
                                    </Button>
                                </Box>
                            )}
        
                            {/* FACULTY */}
                            <Toolbar sx={{ marginTop: '5px', marginBottom: '5px' }} align='center'>
                                <Typography variant='h4' align='left' marginTop="30px" marginBottom="30px" paddingBottom="5px" borderBottom={1} borderColor="divider">
                                Leadership
                                </Typography>
                            </Toolbar>
                    
                            <Grid container direction="row" justifyContent='center' columnSpacing={4} rowSpacing={4}> 
                            {leadershipMembers.map((person) => (    
                                <PersonCard details={person} renderPerson={renderPerson} key={person._id} isLoggedIn={isLoggedIn} onAdminEdit={handleAdminEditFromCard} />    
                            ))}
                            </Grid>
                            
                            {/* STAFF */}
                            <Toolbar sx={{ marginTop: '40px', marginBottom: '5px' }} align='center'>
                                <Typography variant='h4' align='left' marginTop="30px" marginBottom="30px" paddingBottom="5px" borderBottom={1} borderColor="divider">
                                Staff
                                </Typography>
                            </Toolbar>
                            
                            <Grid container direction="row" justifyContent='center' columnSpacing={4} rowSpacing={4}> 
                            {staffMembers && staffMembers.map((person) => (    
                                <PersonCard details={person} renderPerson={renderPerson} key={person._id} isLoggedIn={isLoggedIn} onAdminEdit={handleAdminEditFromCard} />    
                            ))}
                            </Grid>

                            {/* POSTDOCS */}
                            <Toolbar sx={{ marginTop: '40px', marginBottom: '5px' }} align='center'>
                                <Typography variant='h4' align='left' marginTop="30px" marginBottom="30px" paddingBottom="5px" borderBottom={1} borderColor="divider">
                                Postdocs
                                </Typography>
                            </Toolbar>
        
                            <Grid container direction="row" justifyContent='center' columnSpacing={4} rowSpacing={4}> 
                            {postdocMembers && postdocMembers.map((person) => (    
                                <PersonCard details={person} renderPerson={renderPerson} key={person._id} isLoggedIn={isLoggedIn} onAdminEdit={handleAdminEditFromCard} />    
                            ))}
                            </Grid>
                            
                            {/* GRAD STUDENTS */}
                            <Toolbar sx={{ marginTop: '40px', marginBottom: '5px' }} align='center'>
                                <Typography variant='h4' align='left' marginTop="30px" marginBottom="30px" paddingBottom="5px" borderBottom={1} borderColor="divider">
                                Graduate Students
                                </Typography>
                            </Toolbar>
        
                            <Grid container direction="row" justifyContent='center' columnSpacing={4} rowSpacing={4}> 
                            {gradMembers && gradMembers.map((person) => (    
                                <PersonCard details={person} renderPerson={renderPerson} key={person._id} isLoggedIn={isLoggedIn} onAdminEdit={handleAdminEditFromCard} />    
                            ))}
                            </Grid>

                            {/* FACULTY AFFILIATES */}
                            <Toolbar sx={{ marginTop: '40px', marginBottom: '5px' }} align='center'>
                                <Typography variant='h4' align='left' marginTop="30px" marginBottom="30px" paddingBottom="5px" borderBottom={1} borderColor="divider">
                                Faculty and Partner Affiliates
                                </Typography>
                            </Toolbar>
                            <Grid container direction="row" justifyContent='center' columnSpacing={4} rowSpacing={4}> 
                            {facAffMembers && facAffMembers.map((person) => (
                                <AffiliateCard details={person} key={person._id} isLoggedIn={isLoggedIn} onAdminEdit={handleAdminEditFromCard} />
                            ))}
                            </Grid>

                            {/* FACULTY AFFILIATES */}
                            <Toolbar sx={{ marginTop: '40px', marginBottom: '5px' }} align='center'>
                                <Typography variant='h4' align='left' marginTop="30px" marginBottom="30px" paddingBottom="5px" borderBottom={1} borderColor="divider">
                                Student Affiliates
                                </Typography>
                            </Toolbar>
                            <Grid container direction="row" justifyContent='center' columnSpacing={4} rowSpacing={4}> 
                            {studAffMembers && studAffMembers.map((person) => (
                                <AffiliateCard details={person} key={person._id} isLoggedIn={isLoggedIn} onAdminEdit={handleAdminEditFromCard} />
                            ))}
                            </Grid>


                            {/* CENTER ALUMNI */}
                            <Toolbar sx={{ marginTop: '40px', marginBottom: '5px' }} align='center'>
                                <Typography variant='h4' align='left' marginTop="30px" marginBottom="30px" paddingBottom="5px" borderBottom={1} borderColor="divider">
                                Center Alumni
                                </Typography>
                            </Toolbar>
        
                            <Grid container direction="row" justifyContent='center' columnSpacing={4} rowSpacing={4}> 
                            {alumniMembers && alumniMembers.map((person) => (    
                                <PersonCard details={person} renderPerson={renderPerson} key={person._id} isLoggedIn={isLoggedIn} onAdminEdit={handleAdminEditFromCard} />    
                            ))}
                            </Grid>
                        </Container>
                    )
                    )}
                </div>
            )}
            
        </Container>  
           
    )

}

export default People